import React from "react";
import { BeatLoader } from "react-spinners";

export default ({ ...props }) => <BeatLoader color={"#000000"} {...props} />;



// WEBPACK FOOTER //
// ./src/components/util/Spinner.js